import type { LocalStorageEntries } from '@sorare/core/src/lib/storage/localStorage';
import type { SessionStorageEntries } from '@sorare/core/src/lib/storage/sessionStorage';

import { isTrustedTwaReferrer } from './isTrustedTwaReferrer.ts';

export const queryParamsToLocalStorageKeys: Record<
  string,
  keyof LocalStorageEntries
> = {
  utm_source: 'UTM_SOURCE',
  referrer: 'REFERRER',
  utm_medium: 'UTM_MEDIUM',
  utm_campaign: 'UTM_CAMPAIGN',
  utm_term: 'UTM_TERM',
  utm_content: 'UTM_CONTENT',
  irclickid: 'IMPACT_CLICKID',
  gclid: 'GOOGLE_CLICKID',
  fbclid: 'FACEBOOK_CLICKID',
  twclid: 'TWITTER_CLICKID',
  ttclid: 'TIKTOK_CLICKID',
  ScCid: 'SNAPCHAT_CLICKID',
  rdt_cid: 'REDDIT_CLICKID',
  invitation_token: 'INVITATION_TOKEN',
  traffic_category: 'TRAFFIC_CATEGORY',
  partner: 'PARTNER',
  user: 'USER',
  onboardingPro: 'ONBOARDING_PRO',
  referrer_code: 'REFERRER_CODE',
  // Alias of `referrer_code`, matching the `signup_code` naming the AppsFlyer
  // OneLink uses for the native app. Listed last so it wins if both are present.
  signup_code: 'REFERRER_CODE',
} as const;

const TWA_ONLY_QUERY_PARAMS = ['twa', 'fcmToken'];

export const canPersistSessionStorageParam = (
  qsKey: string,
  referrer: string
) => !TWA_ONLY_QUERY_PARAMS.includes(qsKey) || isTrustedTwaReferrer(referrer);

export const queryParamsToSessionStorageKeys: Record<
  string,
  keyof SessionStorageEntries
> = {
  force_flag: 'forcedFlag',
  mobileApp: 'mobileApp',
  appBuildVersionNumber: 'appBuildVersionNumber',
  twa: 'twa',
  fcmToken: 'fcmToken',
  googlePlayStoreCountryCode: 'googlePlayStoreCountryCode',
  storefrontCountryCode: 'storefrontCountryCode',
  deeplink: 'deeplink',
} as const;
